import { createActionLayout } from '@malesia/react-components/dist/src/components/Table/columns/actionsColumn/actionLayout';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const editUserPermissions = createActionLayout({
    text: (
        <FormattedMessage
            id='front-app/UserPermissionsTable:editTitle'
            defaultMessage='Edit permissions'
        />
    ),
    iconName: 'edit',
});
